export function changeViewport(viewport) {
    return {
        type: "CHANGE_VIEW_PORT",
        payload: {
            ...viewport
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/viewportActions.js